import * as React from 'react/jsx-runtime'
import type { FabricReactElement, FabricReactNode } from './types.ts'

export const Fragment = React.Fragment
export const jsxDEV = React.jsx

export type * from './jsx-namespace.d.ts'

export type JSXElement = FabricReactElement
export type ReactNode = FabricReactNode
